import { render, staticRenderFns } from "./MyPath.vue?vue&type=template&id=206261a4"
import script from "./MyPath.vue?vue&type=script&lang=js"
export * from "./MyPath.vue?vue&type=script&lang=js"
import style0 from "./MyPath.vue?vue&type=style&index=0&id=206261a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports